import { Injectable, inject } from '@angular/core';
import { UserService } from '../../service/user.service';
import * as actions from './user.actions';
import { Actions } from '@ngrx/effects';
import { EffectFactory } from '../../../shared/store/common/effect.factory';

@Injectable()
export class UserEffects {
    private readonly action$ = inject(Actions);
    private readonly api = inject(UserService);


    factory = new EffectFactory(this.action$, actions, this.api).create();

    getUsers$ = this.factory.getUsers;
    createUser$ = this.factory.createUser;

}
